import React from 'react';
import MyAccountStudent from '../components/MyAccountStudent';

const StudentAccount = () => {
  const containerStyle = {
    padding: '20px',
    backgroundColor: '#f0f2f5',
    minHeight: '100vh',
  };

  const titleStyle = {
    fontSize: '28px',
    fontWeight: 'bold',
    marginBottom: '20px',
  };

  return (
    <div style={containerStyle}>
      <MyAccountStudent />
    </div>
  );
};

export default StudentAccount;
